import { Alert } from '@mui/material'

import styled from 'styled-components'

export const InfoBanner = styled.div<{ display: boolean }>`
    ${({ display }) => !display ? 'display: none;' : ''}
    margin-bottom: 30px;
`